import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { domainsLoggedArea } from '../configuration/constants';
import { RoutesEnum } from '../configuration/enums/routes.enum';
import { getCompanyDomain } from '../utils/getCompanyDomain.util';

export const domainLoggedAreaGuard: CanActivateFn = () => {
  const router = inject(Router);
  const domain = getCompanyDomain();

  if (domainsLoggedArea.includes(domain)) {
    return true;
  } else {
    router.navigate([RoutesEnum.NOT_FOUND]);
    return false;
  }
};
